import type { Action } from 'redux';

const defaultState = false;

const RESET = 'tealium/cajaHasAIAssistanceBeenUsed/RESET';
const UPDATE = 'tealium/cajaHasAIAssistanceBeenUsed/UPDATE';

export interface ResetAction extends Action {
  type: typeof RESET;
}

export interface UpdateAction extends Action {
  type: typeof UPDATE;
  value: boolean;
}

export const actionResetCajaHasAIAssistanceBeenUsed = (): ResetAction => ({
  type: RESET,
});

export const actionUpdateCajaHasAIAssistanceBeenUsed = (
  value: boolean,
): UpdateAction => ({
  type: UPDATE,
  value,
});

export default (
  state: State = defaultState,
  action: ResetAction | UpdateAction,
) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest: {
  defaultState: boolean;
  RESET: ResetAction['type'];
  UPDATE: UpdateAction['type'];
} = {
  defaultState,
  RESET,
  UPDATE,
};
